import { render, staticRenderFns } from "./BatchAddQuestions.vue?vue&type=template&id=42889778&scoped=true&"
import script from "./BatchAddQuestions.vue?vue&type=script&lang=js&"
export * from "./BatchAddQuestions.vue?vue&type=script&lang=js&"
import style0 from "./BatchAddQuestions.vue?vue&type=style&index=0&id=42889778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42889778",
  null
  
)

export default component.exports